import { isRecord } from "#/shared/lib/is-record";

export function readBackendErrorMessage(body: unknown): string | undefined {
  if (typeof body === "string") {
    return normalizeBackendErrorMessage(body);
  }

  if (!isRecord(body)) {
    return undefined;
  }

  const error = body.error;

  if (typeof error === "string") {
    const message = normalizeBackendErrorMessage(error);

    if (message !== undefined) {
      return message;
    }
  }

  if (isRecord(error) && typeof error.message === "string") {
    const message = normalizeBackendErrorMessage(error.message);

    if (message !== undefined) {
      return message;
    }
  }

  return typeof body.message === "string"
    ? normalizeBackendErrorMessage(body.message)
    : undefined;
}

function normalizeBackendErrorMessage(message: string): string | undefined {
  const normalized = message.trim();

  if (
    normalized.length === 0 ||
    hasUnsafeControlCharacter(normalized) ||
    /^(?:<!doctype\s+html|<!--|<\?xml(?:\s|>)|<\/?[a-z][^>]*>)/iu.test(
      normalized,
    )
  ) {
    return undefined;
  }

  return normalized;
}

function hasUnsafeControlCharacter(value: string): boolean {
  for (const character of value) {
    const codePoint = character.codePointAt(0);

    if (
      codePoint !== undefined &&
      codePoint < 32 &&
      codePoint !== 9 &&
      codePoint !== 10 &&
      codePoint !== 13
    ) {
      return true;
    }
  }

  return false;
}
